export class GovTradesEnvironment {
  public static getName = () => 'benzinga-gov-trades';
  public static getEnvironment = (env: Record<string, string>) => ({
    token: env['token'] ?? 'bcb21f0e5c2ec60fc1fa834444cf04665e04175a6e860cd5d27c9f25e31808d1',
    url: new URL(env['url'] ?? 'https://api.benzinga.com'),
  });
}
